var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "[1440] \xD0\x9E\xD1\x82\xD0\xBA\xD1\x80\xD1\x8B\xD1\x82\xD0\xB8\xD0\xB5 \xD1\x81\xD1\x87\xD0\xB5\xD1\x82\xD0\xB0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1626,
    transform: "translate(-354 -356)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Bank form_desktop"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 646,
    transform: "translate(-354 -180)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Outer box"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -234,
    y: -180,
    width: 1200,
    height: 582,
    rx: 16,
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Inner box"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vpn"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -16,
    y: -20,
    width: 763,
    height: 90,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 881233648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "x72/VirtualWallet"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 8,
    fill: "#F0F9EA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union",
    filter: "url(#filter0_bi_173_460)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_173_460",
    maskUnits: "userSpaceOnUse",
    x: 17.9883,
    y: 9,
    width: 28,
    height: 13,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 17.9883,
    y: 9,
    width: 28,
    height: 13
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7304 16.1822C45.0398 15.9399 45.0398 15.49 44.7304 15.2477L38.2073 10.1396C37.7912 9.81375 37.1634 10.0947 37.1634 10.6068V12.6644L28.9793 12.6644L20.2017 12.6643C19.5315 12.6643 18.9883 13.2076 18.9883 13.8777V17.4455C18.9883 18.1157 19.5315 18.6589 20.2017 18.6589L37.1634 18.6589V20.8231C37.1634 21.3351 37.7912 21.6162 38.2073 21.2903L44.7304 16.1822Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7304 16.1822C45.0398 15.9399 45.0398 15.49 44.7304 15.2477L38.2073 10.1396C37.7912 9.81375 37.1634 10.0947 37.1634 10.6068V12.6644L28.9793 12.6644L20.2017 12.6643C19.5315 12.6643 18.9883 13.2076 18.9883 13.8777V17.4455C18.9883 18.1157 19.5315 18.6589 20.2017 18.6589L37.1634 18.6589V20.8231C37.1634 21.3351 37.7912 21.6162 38.2073 21.2903L44.7304 16.1822Z",
    fill: "url(#paint0_linear_173_460)",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7304 15.2477L44.9154 15.0115L44.7304 15.2477ZM44.7304 16.1822L44.9154 16.4184L44.7304 16.1822ZM38.2073 10.1396L38.0223 10.3758V10.3758L38.2073 10.1396ZM37.1634 12.6644V12.9644C37.3291 12.9644 37.4634 12.83 37.4634 12.6644H37.1634ZM28.9793 12.6644L28.9793 12.9644H28.9793V12.6644ZM20.2017 12.6643L20.2017 12.3643L20.2017 12.6643ZM20.2017 18.6589V18.9589V18.6589ZM37.1634 18.6589H37.4634C37.4634 18.5794 37.4318 18.5031 37.3755 18.4468C37.3193 18.3905 37.243 18.3589 37.1634 18.3589V18.6589ZM37.1634 20.8231H36.8634V20.8231L37.1634 20.8231ZM38.2073 21.2903L38.3922 21.5265H38.3922L38.2073 21.2903ZM44.5455 15.4839C44.7014 15.606 44.7014 15.8239 44.5455 15.946L44.9154 16.4184C45.3781 16.056 45.3781 15.3739 44.9154 15.0115L44.5455 15.4839ZM38.0223 10.3758L44.5455 15.4839L44.9154 15.0115L38.3922 9.90338L38.0223 10.3758ZM37.4634 10.6068C37.4634 10.3742 37.7797 10.1858 38.0223 10.3758L38.3922 9.90338C37.8027 9.44172 36.8634 9.81533 36.8634 10.6068H37.4634ZM37.4634 12.6644V10.6068H36.8634V12.6644H37.4634ZM28.9793 12.9644L37.1634 12.9644V12.3644L28.9793 12.3644V12.9644ZM20.2017 12.9643L28.9793 12.9644L28.9793 12.3644L20.2017 12.3643L20.2017 12.9643ZM19.2883 13.8777C19.2883 13.3733 19.6972 12.9643 20.2017 12.9643L20.2017 12.3643C19.3659 12.3643 18.6883 13.0419 18.6883 13.8777H19.2883ZM19.2883 17.4455V13.8777H18.6883V17.4455H19.2883ZM20.2017 18.3589C19.6972 18.3589 19.2883 17.95 19.2883 17.4455H18.6883C18.6883 18.2814 19.3659 18.9589 20.2017 18.9589V18.3589ZM37.1634 18.3589L20.2017 18.3589V18.9589L37.1634 18.9589V18.3589ZM37.4634 20.8231V18.6589H36.8634V20.8231H37.4634ZM38.0223 21.0541C37.7797 21.2441 37.4634 21.0557 37.4634 20.8231L36.8634 20.8231C36.8634 21.6146 37.8027 21.9882 38.3922 21.5265L38.0223 21.0541ZM44.5455 15.946L38.0223 21.0541L38.3922 21.5265L44.9154 16.4184L44.5455 15.946Z",
    fill: "url(#paint1_linear_173_460)",
    mask: "url(#path-4-outside-1_173_460)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Union_2",
    filter: "url(#filter1_bi_173_460)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-6-outside-2_173_460",
    maskUnits: "userSpaceOnUse",
    x: 4.31445,
    y: 29.0798,
    width: 23,
    height: 13,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 4.31445,
    y: 29.0798,
    width: 23,
    height: 13
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2322 34.8976C4.92283 35.1399 4.92283 35.5899 5.2322 35.8321L11.7554 40.9403C12.1715 41.2661 12.7992 40.9851 12.7992 40.473L12.7992 38.3088L18.6547 38.3088L25.101 38.3088C25.7712 38.3088 26.3145 37.7656 26.3145 37.0954L26.3145 33.5276C26.3145 32.8575 25.7712 32.3142 25.1011 32.3142L12.7992 32.3142L12.7992 30.2568C12.7992 29.7447 12.1715 29.4637 11.7554 29.7895L5.2322 34.8976Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2322 34.8976C4.92283 35.1399 4.92283 35.5899 5.2322 35.8321L11.7554 40.9403C12.1715 41.2661 12.7992 40.9851 12.7992 40.473L12.7992 38.3088L18.6547 38.3088L25.101 38.3088C25.7712 38.3088 26.3145 37.7656 26.3145 37.0954L26.3145 33.5276C26.3145 32.8575 25.7712 32.3142 25.1011 32.3142L12.7992 32.3142L12.7992 30.2568C12.7992 29.7447 12.1715 29.4637 11.7554 29.7895L5.2322 34.8976Z",
    fill: "url(#paint2_linear_173_460)",
    fillOpacity: 0.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2322 35.8321L5.04724 36.0683L5.2322 35.8321ZM5.2322 34.8976L5.04724 34.6614L5.2322 34.8976ZM11.7554 40.9403L11.9403 40.7041L11.9403 40.7041L11.7554 40.9403ZM12.7992 38.3088L12.7992 38.0088C12.6335 38.0088 12.4992 38.1431 12.4992 38.3088L12.7992 38.3088ZM18.6547 38.3088L18.6547 38.0088L18.6547 38.0088L18.6547 38.3088ZM25.101 38.3088L25.101 38.0088L25.101 38.3088ZM12.7992 32.3142L12.4992 32.3142C12.4992 32.4799 12.6335 32.6142 12.7992 32.6142L12.7992 32.3142ZM12.7992 30.2568L12.4992 30.2568L12.7992 30.2568ZM11.7554 29.7895L11.5704 29.5533L11.7554 29.7895ZM5.41716 35.5959C5.26117 35.4738 5.26117 35.256 5.41716 35.1338L5.04724 34.6614C4.58448 35.0238 4.58448 35.706 5.04724 36.0683L5.41716 35.5959ZM11.9403 40.7041L5.41716 35.5959L5.04724 36.0683L11.5704 41.1765L11.9403 40.7041ZM12.4992 40.473C12.4992 40.7057 12.183 40.8941 11.9403 40.7041L11.5704 41.1765C12.16 41.6381 13.0992 41.2645 13.0992 40.473L12.4992 40.473ZM12.4992 38.3088L12.4992 40.473L13.0992 40.473L13.0992 38.3088L12.4992 38.3088ZM18.6547 38.0088L12.7992 38.0088L12.7992 38.6088L18.6547 38.6088L18.6547 38.0088ZM25.101 38.0088L18.6547 38.0088L18.6547 38.6088L25.101 38.6088L25.101 38.0088ZM26.0145 37.0954C26.0145 37.5999 25.6055 38.0088 25.101 38.0088L25.101 38.6088C25.9369 38.6088 26.6145 37.9313 26.6145 37.0954L26.0145 37.0954ZM26.0145 33.5276L26.0145 37.0954L26.6145 37.0954L26.6145 33.5276L26.0145 33.5276ZM25.1011 32.6142C25.6055 32.6142 26.0145 33.0232 26.0145 33.5276L26.6145 33.5276C26.6145 32.6918 25.9369 32.0142 25.1011 32.0142L25.1011 32.6142ZM12.7992 32.6142L25.1011 32.6142L25.1011 32.0142L12.7992 32.0142L12.7992 32.6142ZM12.4992 30.2568L12.4992 32.3142L13.0992 32.3142L13.0992 30.2568L12.4992 30.2568ZM11.9403 30.0257C12.183 29.8357 12.4992 30.0241 12.4992 30.2568L13.0992 30.2568C13.0992 29.4653 12.16 29.0917 11.5704 29.5533L11.9403 30.0257ZM5.41716 35.1338L11.9403 30.0257L11.5704 29.5533L5.04724 34.6614L5.41716 35.1338Z",
    fill: "url(#paint3_linear_173_460)",
    mask: "url(#path-6-outside-2_173_460)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Union_3",
    filter: "url(#filter2_bi_173_460)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1008 23.0063C10.917 23.2057 10.9169 23.5172 11.1005 23.7167L13.4632 26.2841C13.5586 26.3879 13.6917 26.4467 13.8309 26.4467C13.9701 26.4467 14.1032 26.3879 14.1986 26.2841C19.8704 20.1209 29.0554 20.1209 34.7271 26.2841C34.8226 26.3879 34.9557 26.4467 35.0949 26.4467C35.2341 26.4467 35.3671 26.3879 35.4626 26.2841L37.8253 23.7167C38.0088 23.5173 38.0088 23.206 37.8253 23.0066C30.455 14.9976 18.4826 14.9981 11.1008 23.0063ZM20.5507 33.2768C20.3677 33.4762 20.3679 33.7871 20.5512 33.9863L24.0952 37.8374C24.1906 37.9412 24.3237 38 24.4629 38C24.6021 38 24.7351 37.9412 24.8306 37.8374L28.3746 33.9863C28.5579 33.7871 28.5581 33.4762 28.3751 33.2768C27.8647 32.7206 27.2567 32.2777 26.585 31.9748C25.9133 31.6719 25.1921 31.5155 24.4629 31.5155C23.7337 31.5155 23.0124 31.6719 22.3407 31.9748C21.6691 32.2777 21.0611 32.7206 20.5507 33.2768ZM15.8263 28.141C15.6424 28.3403 15.6422 28.6519 15.8258 28.8515L18.1885 31.4189C18.284 31.5226 18.417 31.5815 18.5561 31.5815C18.6953 31.5815 18.8283 31.5228 18.9238 31.4191C20.3987 29.8177 22.3917 28.9244 24.4629 28.9244C26.5341 28.9244 28.5271 29.8177 30.002 31.4191C30.0975 31.5228 30.2305 31.5815 30.3697 31.5815C30.5088 31.5815 30.6418 31.5226 30.7373 31.4189L33.1 28.8515C33.2834 28.6521 33.2834 28.3408 33.1 28.1414C28.3403 22.9693 20.5972 22.97 15.8263 28.141Z",
    fill: "url(#paint4_linear_173_460)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9905 22.9047C10.7538 23.1614 10.7537 23.5613 10.9901 23.8183L13.3528 26.3857C13.4763 26.5198 13.6491 26.5967 13.8309 26.5967C14.0127 26.5967 14.1855 26.5198 14.309 26.3857C19.9213 20.287 29.0044 20.287 34.6168 26.3857C34.7402 26.5198 34.9131 26.5967 35.0949 26.5967C35.2766 26.5967 35.4495 26.5198 35.573 26.3857L37.9357 23.8183C38.172 23.5615 38.172 23.1619 37.9357 22.9051C30.5059 14.8314 18.4316 14.832 10.9905 22.9047ZM20.4402 33.1753C20.2044 33.4322 20.2047 33.8313 20.4408 34.0879L23.9848 37.939C24.1082 38.0732 24.2811 38.15 24.4629 38.15C24.6447 38.15 24.8175 38.0732 24.941 37.939L28.485 34.0879C28.7211 33.8313 28.7213 33.4322 28.4856 33.1753C27.9619 32.6047 27.3374 32.1495 26.6467 31.838C25.9559 31.5265 25.2136 31.3655 24.4629 31.3655C23.7121 31.3655 22.9699 31.5265 22.2791 31.838C21.5884 32.1495 20.9639 32.6047 20.4402 33.1753ZM15.716 28.0392C15.4792 28.296 15.4789 28.696 15.7155 28.9531L18.0781 31.5205C18.2016 31.6546 18.3744 31.7314 18.5561 31.7315C18.7378 31.7315 18.9107 31.6548 19.0342 31.5207C20.482 29.9487 22.4356 29.0744 24.4629 29.0744C26.4902 29.0744 28.4438 29.9487 29.8916 31.5207C30.0151 31.6548 30.188 31.7315 30.3697 31.7315C30.5514 31.7314 30.7242 31.6546 30.8477 31.5205L33.2103 28.9531C33.4466 28.6963 33.4466 28.2967 33.2103 28.0399C28.3911 22.8031 20.5463 22.804 15.716 28.0392Z",
    stroke: "url(#paint5_linear_173_460)",
    strokeWidth: 0.3,
    strokeLinejoin: "round"
  })))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bi_173_460",
    x: 15.6875,
    y: 6.70215,
    width: 32.5742,
    height: 18.0256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_173_460"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_173_460",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_173_460"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bi_173_460",
    x: 1.69922,
    y: 26.3521,
    width: 27.916,
    height: 18.0256,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_173_460"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_173_460",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_173_460"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bi_173_460",
    x: -6.33789,
    y: -0.300049,
    width: 61.6016,
    height: 55.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 8.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_173_460"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_173_460",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.72 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_173_460"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_173_460",
    x1: 44.9644,
    y1: 15.3286,
    x2: 21.6525,
    y2: 15.3286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62D51D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72BF44",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_173_460",
    x1: 23.9837,
    y1: 14.9955,
    x2: 43.9319,
    y2: 14.3292,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EEA70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_173_460",
    x1: 21.3188,
    y1: 35.0852,
    x2: 4.99836,
    y2: 35.1199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9FFC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62D51D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_173_460",
    x1: 25.9801,
    y1: 36.0843,
    x2: 6.0308,
    y2: 36.7507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3FFD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6E083"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_173_460",
    x1: 19.8531,
    y1: 18.0161,
    x2: 27.1179,
    y2: 36.8488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91DD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB526"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_173_460",
    x1: 17.7129,
    y1: 17,
    x2: 33.1338,
    y2: 34.5925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBFFC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C3F5A5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiIcon);
export default __webpack_public_path__ + "static/media/wifi-icon.96d394fb35b7ba6c0177277dfed8c597.svg";
export { ForwardRef as ReactComponent };